import getStore from '../store/store';
import filterOptions from '../utils/filterOptions';
import { OptionWithPath } from 'owa-options-store';

export default () => filterOptions(getStore().query) as OptionWithPath[];
